import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	leaveTypes: [],
	leaveAllocations: [],
	leavePolicy: null,
	error: "",
	loading: false,
	leavePolicyGroup: [],
};


export const addSingleLeavePolicy = createAsyncThunk(
  "leavePolicy/addSingleLeavePolicy",
  async (values) => {
    try {
      const response = await axios({
        method: "post",
        url: `leave/LeavePolicySetup`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: {
          ...values,
        },
      });

      const data = response.data;

      toast.success(
        <div>
          <ul>
            {data.map((day, index) => (
              <li key={index}>{day.message}</li>
            ))}
          </ul>
        </div>
      );

      return {
        data,
        message: "success",
      };
	}catch (error) {
		debugger;
		const statusCode = error.response ? error.response.status : null;
		const errorData = error.response?.data;
	  
		const errorMessage =
		  errorData && errorData.message
			? errorData.message
			: "Error in adding LeavePolicy. Try again.";
	  
		toast.error(errorMessage);
	  
		return {
		  message: "error",
		};
	  }
    
  }
);


export const LeavePolicyGroupSetup = createAsyncThunk(
	"leavePolicy/LeavePolicyGroupSetup",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `leave/LeavePolicyGroupSetup`,
				data: {
					...values,
				},
			});
			toast.success("LeavePolicy Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			const errorMessage =
				error.response && error.response.data && error.response.data.message
					? error.response.data.message
					: "Error in adding LeavePolicy. Try again.";
			toast.error(errorMessage);
			// console.error(errorMessage);
			return {
				message: "error",
			};
		}
	}
);



export const createValidityEntry = createAsyncThunk(
	"leavePolicy/createValidityEntry ",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `leave-policy/validityEntry`,
				data: {
					...values,
				},
			});
			toast.success("LeavePolicy Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding LeavePolicy try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const addSingleLeaveType = createAsyncThunk(
	"leavePolicy/addSingleLeaveType ",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `leave-policy/createLeaveType`,
				data: {
					...values,
				},
			});
			toast.success("LeaveType Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding LeaveType try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const leaveAllocationAllUsers = createAsyncThunk(
	"leavePolicy/leaveAllocationAllUsers",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `leave-policy/leaveAllocationAllUsers`,
				data: {
					...values,
				},
			});

			// Check if the response indicates that no new allocations were created
			if (data.message === 'No new leave allocations to create') {
				toast.warning("No new leave allocations created, as duplicates were found.");
			} else {
				toast.success("Leave Allocations Added Successfully");
			}

			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Leave Allocations. Try again.");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_leavePolicy
export const deleteLeavePolicy = createAsyncThunk(
	"leavePolicy/deleteLeavePolicy ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `leave-policy/${id}`,
			});

			toast.success("LeavePolicy Deleted");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting leavePolicy try again");
			// console.log(error.message);
		}
	}
);

// leavePolicy_DETAILS
export const loadSingleLeavePolicy = createAsyncThunk(
	"leavePolicy/loadSingleLeavePolicy",
	async (id) => {
		try {
			const data = await axios.get(`leave-policy/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const fetchValidityEntry = createAsyncThunk(
	"leavePolicy/fetchValidityEntry",
	async () => {
		try {
			const { data } = await axios.get(`leave-policy/getValidity/all`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

// leavePolicyS
export const loadAllLeavePolicy = createAsyncThunk(
	"leavePolicy/loadAllLeavePolicy",
	async (yearId, { getState, rejectWithValue }) => {
		try {
			const isValidYearId = (value) => {
				if (value === null || value === undefined || value === "") return false;
				const parsed = Number(value);
				return Number.isInteger(parsed) && parsed > 0;
			};

			let resolvedYearId = yearId;

			// Fallback: derive current year from store when caller doesn't pass YearId.
			if (!isValidYearId(resolvedYearId)) {
				const state = getState();
				const masterData = state?.masters?.masters;
				const companyDetail = state?.setting?.list;
				const useCalendarYear = Boolean(companyDetail?.IsLeaveCalenderYear);
				const years = useCalendarYear
					? masterData?.CalendarYearDetails
					: masterData?.FinancialYearDetails;
				resolvedYearId = years?.find((year) => year.IsCurrent)?.YearId;
			}

			if (!isValidYearId(resolvedYearId)) {
				return rejectWithValue({ message: "Invalid YearId" });
			}

			const { data } = await axios.get(
				`leave/LeavePolicyGetByCompanyId?YearId=${resolvedYearId}`
			);
			return data;
		} catch (error) {
			// console.log(error.message);
			return rejectWithValue({
				message: error.response?.data?.message || error.message,
			});
		}
	}
);
  

export const getAllLeaveAllocation = createAsyncThunk(
	"leavePolicy/getAllLeaveAllocation",
	async () => {
		try {
			const { data } = await axios.get(`leave-policy/getAllLeaveAllocation`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const loadAllLeaveType = createAsyncThunk(
	"leavePolicy/loadAllLeaveType",
	async () => {
		try {
			const { data } = await axios.get(`leave-policy/leaveType`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const LeavePolicyGroupGetByCompanyId = createAsyncThunk(
	"leavePolicy/LeavePolicyGroupGetByCompanyId",
	async () => {
		try {
			const { data } = await axios.get(`leave/LeavePolicyGroupGetByCompanyId`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const updateLeavePolicy = createAsyncThunk(
	"leavePolicy/updateLeavePolicy",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `leave-policy/${id}`,
				data: {
					...values,
				},
			});
			toast.success("LeavePolicy Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating LeavePolicy try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const updateDefaultValidityId = createAsyncThunk(
	"leavePolicy/updateDefaultValidityId",
	async ({ company_id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `leave-policy/updateDefaultValidityId/${company_id}`,
				data: {
					...values,
				},
			});
			toast.success("Default LeavePolicy Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Default LeavePolicy try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);


export const updateValidityEntry = createAsyncThunk(
	"leavePolicy/updateValidityEntry",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `leave-policy/updateValidityEntry/${id}`,
				data: {
					...values,
				},
			});
			toast.success("LeavePolicy Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating LeavePolicy try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const getDefaultValidity = createAsyncThunk(
	"leavePolicy/getDefaultValidity",
	async () => {
		try {
			const { data } = await axios.get(`leave-policy/get/defaultValidity`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const EmployeeLeavePolicyGroupHistorySetup = createAsyncThunk(
	"leavePolicy/EmployeeLeavePolicyGroupHistorySetup",
	async (values) => {
	  try {
		const { data } = await axios({
		  method: "post",
		  headers: {
			Accept: "application/json",
			"Content-Type": "application/json;charset=UTF-8",
		  },
		  url: `employee/EmployeeLeavePolicyGroupHistorySetup`,
		  data: {
			...values,
		  },
		});
		toast.success("Leave Policy Status Added");
		return {
		  data,
		  message: "success",
		};
	  } catch (error) {
		toast.error("Error in adding leave policy try again");
		// console.log(error.message);
		return {
		  message: "error",
		};
	  }
	}
  );

const leavePolicySlice = createSlice({
	name: "leavePolicy",
	initialState,
	reducers: {
		clearLeavePolicy: (state) => {
			state.leavePolicy = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllLeavePolicy ======

		builder.addCase(loadAllLeavePolicy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllLeavePolicy.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload || [];
		});

		builder.addCase(loadAllLeavePolicy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload?.message;
		});

		// 1) ====== builders for getAllLeaveAllocation ======

		builder.addCase(getAllLeaveAllocation.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllLeaveAllocation.fulfilled, (state, action) => {
			state.loading = false;
			state.leaveAllocations = action.payload || [];
		});

		builder.addCase(getAllLeaveAllocation.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});


		// ====== builders for loadAllLeaveType ======

		builder.addCase(loadAllLeaveType.fulfilled, (state, action) => {
			state.leaveTypes = action.payload || [];
		});

		builder.addCase(loadAllLeaveType.rejected, (state, action) => {
			state.error = action.payload?.message;
		});

		// ====== builders for LeavePolicyGroupGetByCompanyId ======

		builder.addCase(LeavePolicyGroupGetByCompanyId.fulfilled, (state, action) => {
			state.leavePolicyGroup = action.payload;
		});

		builder.addCase(LeavePolicyGroupGetByCompanyId.rejected, (state, action) => {
			state.error = action.payload?.message;
		});

		// 2) ====== builders for addSingleLeavePolicy  ======

		builder.addCase(addSingleLeavePolicy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSingleLeavePolicy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addSingleLeavePolicy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for LeavePolicyGroupSetup  ======

		builder.addCase(LeavePolicyGroupSetup.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(LeavePolicyGroupSetup.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(LeavePolicyGroupSetup.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for createValidityEntry  ======

		builder.addCase(createValidityEntry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(createValidityEntry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(createValidityEntry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addSingleLeaveType  ======


		builder.addCase(addSingleLeaveType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSingleLeaveType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addSingleLeaveType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for leaveAllocationAllUsers  ======


		builder.addCase(leaveAllocationAllUsers.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(leaveAllocationAllUsers.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(leaveAllocationAllUsers.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});


		// 3) ====== builders for loadSingleLeavePolicy ======

		builder.addCase(loadSingleLeavePolicy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleLeavePolicy.fulfilled, (state, action) => {
			state.loading = false;
			state.leavePolicy = action.payload.data;
		});

		builder.addCase(loadSingleLeavePolicy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for fetchValidityEntry ======

		builder.addCase(fetchValidityEntry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(fetchValidityEntry.fulfilled, (state, action) => {
			// console.log("API Response:", action.payload);
			state.loading = false;
			state.validity = action.payload;
		});

		builder.addCase(fetchValidityEntry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 3) ====== builders for updateLeavePolicy ======

		builder.addCase(updateLeavePolicy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateLeavePolicy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateLeavePolicy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for updateDefaultValidityId ======

		builder.addCase(updateDefaultValidityId.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateDefaultValidityId.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateDefaultValidityId.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});


		builder.addCase(updateValidityEntry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateValidityEntry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateValidityEntry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteLeavePolicy  ======

		builder.addCase(deleteLeavePolicy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLeavePolicy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteLeavePolicy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for getDefaultValidity ======

		builder.addCase(getDefaultValidity.fulfilled, (state, action) => {
			state.defaultValidity = action.payload;
		});

		builder.addCase(getDefaultValidity.rejected, (state, action) => {
			state.error = action.payload?.message;
		});

			builder.addCase(EmployeeLeavePolicyGroupHistorySetup.pending, (state) => {
			  state.loading = true;
			});
		
			builder.addCase(
			  EmployeeLeavePolicyGroupHistorySetup.fulfilled,
			  (state, action) => {
				state.loading = false;
		
				if (!Array.isArray(state.list)) {
				  state.list = [];
				}
				const list = [...state.list];
				list.push(action.payload);
				state.list = list;
			  }
			);
		
			builder.addCase(
			  EmployeeLeavePolicyGroupHistorySetup.rejected,
			  (state, action) => {
				state.loading = false;
				state.error = action.payload.message;
			  }
			);
		
	},
});

export default leavePolicySlice.reducer;
export const { clearLeavePolicy } = leavePolicySlice.actions;
